const Menu = [
	{ is_header: true, title: 'Navigation' },
	{ path: '/dashboard', icon: 'fa fa-laptop', title: 'Dashboard' },
	{ path: '/analytics', icon: 'fa fa-chart-pie', title: 'Analytics' },
	{ path: '/email', icon: 'fa fa-envelope', title: 'Email', badge: '4',
		children: [
			{ path: '/email/inbox', title: 'Inbox' }, 
			{ path: '/email/compose', title: 'Compose' }, 
			{ path: '/email/detail', title: 'Detail' }
		]
	}, 
	{ is_divider: true }, 
	{ is_header: true, title: 'Components' }, 
	{ path: '/widgets', icon: 'fa fa-qrcode', title: 'Widgets' }, 
	{ path: '/ai', icon: 'fa fa-microchip', title: 'AI Studio',
		children: [
			{ path: '/ai/chat', title: 'AI Chat' }, 
			{ path: '/ai/image-generator', title: 'AI Image Generator' }
		]
	},
	{ path: '/pos', icon: 'fa fa-wallet', title: 'POS System',
		children: [
			{ path: '/pos/customer-order', title: 'Customer Order' }, 
			{ path: '/pos/kitchen-order', title: 'Kitchen Order' }, 
			{ path: '/pos/counter-checkout', title: 'Counter Checkout' }, 
			{ path: '/pos/table-booking', title: 'Table Booking' }, 
			{ path: '/pos/menu-stock', title: 'Menu Stock' }
		]
	}, 
	{ path: '/ui', icon: 'fa fa-heart', title: 'UI Kits',
		children: [
			{ path: '/ui/bootstrap', title: 'Bootstrap' }, 
			{ path: '/ui/buttons', title: 'Buttons' }, 
			{ path: '/ui/card', title: 'Card' }, 
			{ path: '/ui/icons', title: 'Icons' }, 
			{ path: '/ui/modal-notifications', title: 'Modal & Notifications' }, 
			{ path: '/ui/typography', title: 'Typography' }, 
			{ path: '/ui/tabs-accordions', title: 'Tabs & Accordions' }
		]
	}, 
	{ path: '/form', icon: 'fa fa-file-alt', title: 'Forms',
		children: [
			{ path: '/form/elements', title: 'Form Elements' }, 
			{ path: '/form/plugins', title: 'Form Plugins' }, 
			{ path: '/form/wizards', title: 'Wizards' }
		]
	}, 
	{ path: '/table', icon: 'fa fa-table', title: 'Tables',
		children: [
			{ path: '/table/elements', title: 'Table Elements' },
			{ path: '/table/plugins', title: 'Table Plugins' }
		]
	}, 
	{ path: '/chart', icon: 'fa fa-chart-bar', title: 'Charts',
		children: [
			{ path: '/chart/chart-js', title: 'Chart.js' },
			{ path: '/chart/chart-apex', title: 'Apexcharts.js' }
		]
	}, 
	{ path: '/map', icon: 'fa fa-map-marker-alt', title: 'Map' }, 
	{ path: '/layout', icon: 'fa fa-code-branch', title: 'Layout',
		children: [
			{ path: '/layout/starter-page', title: 'Starter Page' }, 
			{ path: '/layout/fixed-footer', title: 'Fixed Footer' }, 
			{ path: '/layout/full-height', title: 'Full Height' }, 
			{ path: '/layout/full-width', title: 'Full Width' }, 
			{ path: '/layout/boxed-layout', title: 'Boxed Layout' }, 
			{ path: '/layout/minified-sidebar', title: 'Minified Sidebar' }, 
			{ path: '/layout/top-nav', title: 'Top Nav' }, 
			{ path: '/layout/mixed-nav', title: 'Mixed Nav' }, 
			{ path: '/layout/mixed-nav-boxed-layout', title: 'Mixed Nav Boxed Layout' }
		]
	}, 
	{ path: '/pages', icon: 'fa fa-globe', title: 'Pages',
		children: [
			{ path: '/pages/scrum-board', title: 'Scrum Board' }, 
			{ path: '/pages/products', title: 'Products' }, 
			{ path: '/pages/product-details', title: 'Product Details' }, 
			{ path: '/pages/orders', title: 'Orders' }, 
			{ path: '/pages/order-details', title: 'Order Details' }, 
			{ path: '/pages/gallery', title: 'Gallery' }, 
			{ path: '/pages/search-results', title: 'Search Results' }, 
			{ path: '/pages/coming-soon', title: 'Coming Soon Page' }, 
			{ path: '/pages/error', title: 'Error Page' }, 
			{ path: '/pages/login', title: 'Login' }, 
			{ path: '/pages/register', title: 'Register' }, 
			{ path: '/pages/messenger', title: 'Messenger' }, 
			{ path: '/pages/data-management', title: 'Data Management' },
			{ path: '/pages/file-manager', title: 'File Manager' }, 
			{ path: '/pages/pricing', title: 'Pricing Page' }
		]
	}, 
	{ path: '/landing', icon: 'fa fa-crown', title: 'Landing Page' }, 
	{ is_divider: true }, 
	{ is_header: true, title: 'Users' }, 
	{ path: '/profile', icon: 'fa fa-user-circle', title: 'Profile' }, 
	{ path: '/calendar', icon: 'fa fa-calendar', title: 'Calendar' }, 
	{ path: '/settings', icon: 'fa fa-cog', title: 'Settings' }, 
	{ path: '/helper', icon: 'fa fa-question-circle',	title: 'Helper' }
];

export default Menu;